import { roundToDecimals } from 'core/common/utils/number';

export const getPriceBeforeDiscount = (
  price: number,
  discountPercent: number,
  minorUnits: number,
): number | null => {
  const percentBase = 100;
  const charmPriceOffset = 0.01;

  const isDiscountValid = discountPercent > 0 && discountPercent < percentBase;

  if (!isDiscountValid) {
    return null;
  }

  const exactPrice = roundToDecimals(price / (1 - discountPercent / percentBase));
  const roundedUpPrice = Math.ceil(exactPrice);
  const priceBeforeDiscount = minorUnits ? roundedUpPrice - charmPriceOffset : roundedUpPrice;

  if (priceBeforeDiscount <= price) {
    return null;
  }

  return priceBeforeDiscount;
};
